module.exports = __webpack_public_path__ + "static/media/cockroach(7).dab96742.PNG";